import { render, staticRenderFns } from "./BeneficiaryBadgeShow.vue?vue&type=template&id=2da6d396&scoped=true&"
import script from "./BeneficiaryBadgeShow.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryBadgeShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da6d396",
  null
  
)

export default component.exports